import { get } from "./api";

export const getStats = async (id: string) => {
  const url = `/projects/${id}/stats`;
  const data = await get(url);
  return data;
};
